var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFinance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.84342 5.83268H9.17676M5.84342 9.16602H12.5101M5.84342 12.4993H12.5101M3.34342 1.66602H15.0101C15.9306 1.66602 16.6768 2.41221 16.6768 3.33268V15.9613C16.6768 17.1156 15.5317 17.9204 14.4456 17.5294L13.1441 17.0609C12.7374 16.9145 12.2898 16.9318 11.8956 17.1092L9.8607 18.0249C9.42574 18.2206 8.92777 18.2206 8.49282 18.0249L6.4579 17.1092C6.06375 16.9318 5.6161 16.9145 5.20943 17.0609L3.90796 17.5294C2.82185 17.9204 1.67676 17.1156 1.67676 15.9613V3.33268C1.67676 2.41221 2.42295 1.66602 3.34342 1.66602Z",
    stroke: "#00535C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFinance);
export default __webpack_public_path__ + "static/media/icon-finance.0ad809c0.svg";
export { ForwardRef as ReactComponent };